import axios from "axios";

export const authAxios = axios.create({
	baseURL: process.env.RAZZLE_AUTH_URL,
	transformRequest: [
		(data, headers) => {
			data.client_id = process.env.RAZZLE_CLIENT_ID;
			data.client_secret = process.env.RAZZLE_CLIENT_SECRET;
			return data;
		},
		...axios.defaults.transformRequest,
	],
});

export const apiAxios = axios.create({
	baseURL: process.env.RAZZLE_API_URL,
	timeout: 30000,
});

export const localAxios = axios.create({
	baseURL: `${process.env.RAZZLE_BASE_URL}api`,
});

export const reportAxios = axios.create({
	baseURL: `${process.env.RAZZLE_REPORT_URL}`,
});
